<template>
  <el-dialog
    id="bb"
    :center="true"
    :close-on-click-modal="false"
    title="模板设置"
    :visible.sync="showEdit"
    @close="closeEditDialog"
  >
    <el-form :rules="rules" ref="template" :model="template">
      <el-form-item label="模板名称：" style="width: 100%;">
        <span>{{ template.templateName }}</span>
      </el-form-item>
      <el-form-item label="模板是否可上传文件：">
        <span v-if="template.templateType ==='1'">是</span>
        <span v-if="template.templateType ==='2'">否</span>
      </el-form-item>
      <el-form-item label="模板状态：">
        <span v-if="template.templateStatus ==='1'">启用</span>
        <span v-if="template.templateStatus ==='2'">失效</span>
      </el-form-item>
      <el-form-item label="模板设置：">
        <el-form-item v-for="(item,index) in template.templateArr" :key="index">
          <el-form-item :label="'问题'+(index + 1)+'：'">
            <span>{{item.question }}</span>
          </el-form-item>
          <el-form-item style="    margin-left: 82px;" :label="'回答'+(index + 1)+'：'">
            <span>{{item.answer }}</span>
          </el-form-item>
        </el-form-item>
        <el-form-item >

        </el-form-item>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeEditDialog">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios";
import apiBaseUrl from '../../../config/api';

export default {
  components: {},
  data() {
    return {
      showEdit: false,
      rules: {},
      template: {
        templateName: '',
        templateStatus: '',
        templateType:'',
        templateArr: [{
          question: '',
          answer: ''
        }]
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    //添加输入框
    addInput() {
      this.template.templateArr.push({
        question: '',
        answer: '',
      })
    },
    //减少输入框
    removeItem() {
      if (this.template.templateArr.length > 1) {
        this.template.templateArr.pop()
      } else {
        this.template.templateArr.splice(0, this.template.templateArr.length)
      }
    },
    init(id) {
      axios
        .get(`${apiBaseUrl}/template/getById/${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.template.templateName = res.data.data.templateName
          this.template.templateStatus = res.data.data.templateStatus + ''
          this.template.templateType = res.data.data.templateType + ''
          this.template.templateArr = JSON.parse(res.data.data.templateSet)
          this.showEdit = true
        })
    },
    closeEditDialog() {
      this.showEdit = false

    },
  },
  beforeCreate() {
  },

  created() {

  },

  beforeMount() {

  },

  mounted() {

  },

  beforeUpdate() {

  },

  updated() {

  },

  beforeDestroy() {

  },
  destroyed() {

  },

  activated() {

  },
}


</script>

<style scoped>
/* 兼容移动端 */
@media screen and (max-width: 750px) {

  /* 兼容移动端 */
  #bb >>> .el-dialog {
    width: 83%;
  }
}
</style>




// WEBPACK FOOTER //
// src/manager/components/TemplateDet.vue